export default [
  {
    shortCode: 'CA',
    monerisCode: 'CA',
    APICode: 'CAD'
  }
]
